module.exports = __webpack_public_path__ + "static/media/regedit_202.16516ff0.ico";